import React from 'react';
import { GlobalState } from 'types/globalState';
export const FormModalContext = React.createContext<GlobalState>({} as GlobalState);
export const MapScheduleContext = React.createContext(undefined);
export const SearchContext = React.createContext(undefined);
export const CustomerJobWrapperContext = React.createContext(undefined);
export const CustomerDetailContext = React.createContext(undefined);
